import { FallbackBankSVG } from '@svgComponents/fallbackBankSVG';
import { FormattedMessage } from 'react-intl';

import { getBankLogo } from './getBankLogo';

export const LinkedAccount = ({
    account
}: {
    account: {
        bankName?: string;
        logoUrl?: string;
        accountNumberMasked?: string;
    };
}) => {
    const { bankName, logoUrl, accountNumberMasked } = account;
    const logoSrc = logoUrl || getBankLogo(bankName);

    return (
        <div className="flex items-center gap-s rounded-xs border border-secondary-80 bg-secondary-95 p-l">
            {logoSrc ? (
                <img
                    src={logoSrc}
                    alt=""
                    data-testid="linked-account-bank-logo"
                    className="fs-mask dd-privacy-mask h-[40px] w-[40px] shrink-0 rounded-full object-contain"
                />
            ) : (
                <FallbackBankSVG className="h-[40px] w-[40px] shrink-0" />
            )}
            <span className="text-s font-bold text-primary-10">
                {bankName ? (
                    accountNumberMasked ? (
                        <FormattedMessage
                            id="_.bank_selection_modal.linked_account_row"
                            defaultMessage="{bankName} account ending in {accountNumberMasked} is linked"
                            values={{ bankName, accountNumberMasked }}
                        />
                    ) : (
                        <FormattedMessage
                            id="_.bank_selection_modal.linked_account_row_no_number"
                            defaultMessage="{bankName} account is linked"
                            values={{ bankName }}
                        />
                    )
                ) : accountNumberMasked ? (
                    <FormattedMessage
                        id="_.bank_selection_modal.linked_account_row_unknown_bank"
                        defaultMessage="Account ending in {accountNumberMasked} is linked"
                        values={{ accountNumberMasked }}
                    />
                ) : (
                    <FormattedMessage
                        id="_.bank_selection_modal.linked_account_row_unknown_bank_no_number"
                        defaultMessage="Bank account is linked"
                    />
                )}
            </span>
        </div>
    );
};
